import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagPt = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 26.67,
	height: 22,
	viewBox: "0 0 32 32",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5,4H13V28H5c-2.208,0-4-1.792-4-4V8c0-2.208,1.792-4,4-4Z",
			fill: "#2b6519"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16,4h15V28h-15c-2.208,0-4-1.792-4-4V8c0-2.208,1.792-4,4-4Z",
			transform: "rotate(180 21.5 16)",
			fill: "#ea3323"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
			opacity: .15
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
			fill: "#fff",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 16,
			r: 5,
			fill: "#ff5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.562,13.529l-5.125-.006v3.431h0c.004,.672,.271,1.307,.753,1.787,.491,.489,1.132,.759,1.805,.759,.684,0,1.328-.267,1.813-.75,.485-.484,.753-1.126,.753-1.808v-3.413Z",
			fill: "#ea3323"
		})
	]
});
const ForwardRef = forwardRef(SvgFlagPt);
export { ForwardRef as ReactComponent };
